export const BIG_SCREEN_BREAKPOINT = 1366